import * as React from "react";
import { Component } from "react";
import H from "history";
import { Redirect } from "react-router";
import {SchoolWithAccessLevel} from "../../models/School";
import DispatchProps from "../../utils/DispatchProps";
import {IRootState} from "../../store";
import {connect} from "react-redux";
import LoadingPage from "../LoadingPage";

interface HomeRedirectProps {
    history: H.History;
    schoolsCanAccess?: SchoolWithAccessLevel[];
    userIsCdbEmployee: boolean
}

interface HomeRedirectState {
}

class HomeRedirect extends Component<HomeRedirectProps & DispatchProps,HomeRedirectState> {

    constructor(props: HomeRedirectProps & DispatchProps) {
        super(props);

        this.state = {
        };
    }

    async componentDidMount(): Promise<void> {

    }

    async componentDidUpdate(prevProps: Readonly<HomeRedirectProps & DispatchProps>, prevState: any): Promise<void> {
    }

    public render(): JSX.Element | undefined {
        
        if(this.props.userIsCdbEmployee)
        {
            return (
                <Redirect to={"/cdb-admin/home"}/>
            );
        }
        
        if(this.props.schoolsCanAccess === undefined)
        {
            return <LoadingPage/>
        }
        
        if(this.props.schoolsCanAccess.length === 0)
        {
            return <Redirect to={"/manage/no-access"}/>
        }
        else
        {
            const firstSchoolWithAccessLevel = this.props.schoolsCanAccess[0];
            return <Redirect to={`/manage/${firstSchoolWithAccessLevel.school.tenantId}/${firstSchoolWithAccessLevel.school.schoolCode}`}/>
        }
    }
}

export default connect(
    (state: IRootState): HomeRedirectProps => {
        return {
            history: state.history,
            schoolsCanAccess: state.schools.schoolsCanAccess,
            userIsCdbEmployee: state.auth.userIsCdbEmployee,
        };
    }
)(HomeRedirect)